import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getPurBillNo = createAsyncThunk('/prosafe/getPurBillNo',
    async ({ formData }) => {
        try {
            const myurl = `${V_URL}/prosafe/pro-list-pu-bill-no`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: formData,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN'),
                },
            });
            
            const data = response.data;
            // console.log(data, "getPurBillNo response");

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error
        }
    })

const getPurBillNoSlice = createSlice({
    name: "getPurBillNo",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPurBillNo.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getPurBillNo.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getPurBillNo.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getPurBillNoSlice.reducer;